import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import utils from '@/axios/utils'
import fetch from '@/axios/fetch'
// 解决多次点击重复路由报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
// 二级跳转通用视图
const routerView = resolve => require(['components/router-view'], resolve)

// 登录
const Login = resolve => require(['pages/user/login'], resolve)
// 登录
const Updatapwd = resolve => require(['pages/user/updatapwd'], resolve)
// 注册
const Register = resolve => require(['pages/user/register'], resolve)
// 第三方注册
const Register1 = resolve => require(['pages/user/register1'], resolve)
// 主页
const Home = resolve => require(['pages/home'], resolve)

Vue.use(Router)

const router = new Router({
  routes: [
    // 登录
    { path: '/login', name: 'login', component: Login, meta: { bodyClassName: 'white', requireAuth: false, title: '登录' }},
    { path: '/register', name: 'register', component: Register, meta: { bodyClassName: 'white', requireAuth: false, title: '注册' }},
    { path: '/register1', name: 'register1', component: Register1, meta: { bodyClassName: 'white', requireAuth: false, title: '注册' }},
    { path: '/updatapwd', name: 'updatapwd', component: Updatapwd, meta: { bodyClassName: 'white', requireAuth: false, title: '找回密码' }},
    { path: '/agreement', name: 'agreement', component: resolve => require(['pages/user/components/agreement'], resolve), meta: { bodyClassName: 'white', requireAuth: false, title: '用户协议' }},
    { path: '/privacyPolicy', name: 'privacyPolicy', component: resolve => require(['pages/user/components/privacyPolicy'], resolve), meta: { bodyClassName: 'white', requireAuth: false, title: '隐私政策' }},
    { path: '/scanningCode', name: 'scanningCode', component: resolve => require(['pages/scanningCode/index'], resolve), meta: { bodyClassName: 'white', requireAuth: false, title: '扫一扫' }},
    { path: '/userEdit', name: 'userEdit', component: resolve => require(['pages/myComponents/userEdit'], resolve), meta: { bodyClassName: 'white', requireAuth: false, title: '编辑信息' }},
    { path: '/assessment', name: 'assessment', component: resolve => require(['pages/myComponents/assessment'], resolve), meta: { bodyClassName: 'white', requireAuth: false, title: '我的测评' }},
    { path: '/evaluationReport', name: 'evaluationReport', component: resolve => require(['pages/myComponents/evaluationReport'], resolve), meta: { bodyClassName: 'white', requireAuth: false, title: '测评报告' }},
    { path: '/evaluationAccess', name: 'evaluationAccess', component: resolve => require(['pages/user/evaluationAccess'], resolve), meta: { bodyClassName: 'white', requireAuth: false, title: '测评答题' }},
    {
      path: '/', component: routerView,
      redirect: 'home',
      children: [
        { path: 'home', name: 'home', component: Home, meta: { bodyClassName: 'white', requireAuth: true, title: '首页' }},

        // 更多新闻列表

        // {
        //   path: 'moreNewsList',
        //   name: 'moreNewsList',
        //   component: resolve => require(['pages/home/components/moreComponents/moreNewsList'], resolve),
        //   meta: { bodyClassName: 'white', requireAuth: true, title: '更多职位', keepAlive: false }
        // },
        // // 新闻详情

        // {
        //   path: 'newDetailList',
        //   name: 'newDetailList',
        //   component: resolve => require(['pages/home/components/moreComponents/newDetailList'], resolve),
        //   meta: { bodyClassName: 'white', requireAuth: true, title: '新闻详情', keepAlive: false }
        // },
        // 我的
        {
          path: 'myComponents',
          name: 'myComponents',
          component: resolve => require(['pages/myComponents'], resolve),
          meta: { bodyClassName: 'white', requireAuth: true, title: '我的' }

        }
        // {
        //   path: 'companyProduct',
        //   name: 'companyProduct',
        //   component: resolve => require(['pages/companyProduct'], resolve),
        //   meta: { bodyClassName: 'white', requireAuth: true, title: '产品' }

        // },
        // {
        //   path: 'caseList',
        //   name: 'caseList',
        //   component: resolve => require(['pages/caseList'], resolve),
        //   meta: { bodyClassName: 'white', requireAuth: true, title: '合作案例' }

        // }
      ]
    },

    // 设置
    {
      path: '/setComponent',
      name: 'setComponent',
      component: resolve => require(['pages/myComponents/setComponent'], resolve),
      meta: { bodyClassName: 'white', requireAuth: false, title: '设置' }
    },
    // 密码修改
    {
      path: '/changePassword',
      name: 'changePassword',
      component: resolve => require(['pages/myComponents/changePassword'], resolve),
      meta: { bodyClassName: 'white', requireAuth: false, title: '密码修改' }
    }
    // {
    //   path: '/enter', component: routerView,
    //   children: [
    //     { path: '/', name: 'enter', component: resolve => require(['pages/enter/index'], resolve), meta: { requireAuth: false, title: '入驻记录' }},
    //     { path: 'paymentRecords', name: 'paymentRecords', component: resolve => require(['pages/enter/paymentRecords'], resolve), meta: { requireAuth: false, title: '缴费记录' }},
    //     { path: 'enterList', name: 'enterList', component: resolve => require(['pages/enter/enterList'], resolve), meta: { requireAuth: false, title: '入驻' }},
    //     { path: 'addInfo', name: 'addInfo', component: resolve => require(['pages/enter/addInfo'], resolve), meta: { requireAuth: false, title: '入驻信息' }}

    //   ]
    // },

    // {
    //   path: '/case', component: routerView,
    //   children: [
    //     { path: '/', name: 'case', component: resolve => require(['pages/case/index'], resolve), meta: { requireAuth: false, title: '产品中心' }}

    //   ]
    // },
    // {
    //   path: '/caseExmble', component: routerView,
    //   children: [
    //     { path: '/', name: 'caseExmble', component: resolve => require(['pages/caseExmble/index'], resolve), meta: { requireAuth: false, title: '案例详情' }}

    //   ]
    // }
  ],
  scrollBehavior(to, from, savedPosition) {
    // keep-alive 返回缓存页面后记录浏览位置
    if (savedPosition && to.meta.keepAlive) {
      return savedPosition
    }
    // 异步滚动操作
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ x: 0, y: 1 })
      }, 0)
    })
  }

})

router.beforeEach(async(to, from, next) => {
  document.body.className = to.meta.bodyClassName
  // setTimeout(_ => {
  //   window.scrollTo(0, 0)
  // }, 400)

  if (!to.name) {
    next({ name: 'page404' })
    return
  }
  const tenantId = utils.getLocalStorage('tenantId')
  if (tenantId == '') {
    await fetch.getTenantByDomainArray()
  }
  // var tokenInfo = store.state.token.data;
  // if (to.name == 'login' && tokenInfo) {
  //   next({ path: '/' });
  //   return;
  // }
  // if (to.meta.requireAuth) {
  //   if (tokenInfo) {
  //     next()
  //   } else {
  //     next({ name: 'login' });
  //   }
  // }
  next()
})

router.afterEach(function(to) {
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js